// Facebook Pixel tracking utilities

/**
 * Track a custom event with Facebook Pixel
 * @param {string} eventName - Standard or custom event name
 * @param {object} params - Optional event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (window.fbq) {
    window.fbq('track', eventName, params);
    console.log('FB Pixel Event:', eventName, params);
  } else {
    console.warn('Facebook Pixel not initialized');
  }
};

/**
 * Track a custom conversion event
 * @param {string} eventName - Custom event name
 * @param {object} params - Optional event parameters
 */
export const trackCustomEvent = (eventName, params = {}) => {
  if (window.fbq) {
    window.fbq('trackCustom', eventName, params);
    console.log('FB Pixel Custom Event:', eventName, params);
  } else {
    console.warn('Facebook Pixel not initialized');
  }
};

// Standard Facebook Events
export const FBEvents = {
  // Core conversion events YOU'RE ACTUALLY USING
  COMPLETE_REGISTRATION: 'CompleteRegistration',  // ✅ ACTIVE - RegisterPage.jsx
  SUBSCRIBE: 'Subscribe',                         // ✅ ACTIVE - SubscriptionPage.jsx
  INITIATE_CHECKOUT: 'InitiateCheckout',          // ✅ ACTIVE - SubscriptionPage.jsx
  
  // Custom events YOU'RE ACTUALLY USING
  CARD_CREATED: 'CardCreated',                    // ✅ ACTIVE - useAutoSaveCard.jsx
  
  // Other standard events (available but not currently used)
  PURCHASE: 'Purchase',
  LEAD: 'Lead',
  START_TRIAL: 'StartTrial',
  ADD_TO_CART: 'AddToCart',
  ADD_TO_WISHLIST: 'AddToWishlist',
  ADD_PAYMENT_INFO: 'AddPaymentInfo',
  VIEW_CONTENT: 'ViewContent',
  SEARCH: 'Search',
  
  // Custom events (available but not currently used)
  CARD_EDITED: 'CardEdited',
  CARD_SHARED: 'CardShared',
  CARD_DOWNLOADED: 'CardDownloaded',
};

// Convenience methods for common events
export const fbPixel = {
  // Direct access to base tracking functions
  trackEvent,
  trackCustomEvent,

  // Track user registration
  trackRegistration: (method = 'email') => {
    trackEvent(FBEvents.COMPLETE_REGISTRATION, {
      content_name: 'User Registration',
      status: 'completed',
      registration_method: method,
    });
  },

  // Track subscription purchase
  trackSubscription: (plan, value, currency = 'USD') => {
    trackEvent(FBEvents.SUBSCRIBE, {
      value: value,
      currency: currency,
      predicted_ltv: value * 12, // Estimate lifetime value
      content_name: plan,
    });
  },

  // Track card creation (custom event)
  trackCardCreated: (cardType = 'custom') => {
    trackCustomEvent(FBEvents.CARD_CREATED, {
      content_type: 'greeting_card',
      card_type: cardType,
    });
  },

  // Track card completion/download
  trackCardDownload: () => {
    trackCustomEvent(FBEvents.CARD_DOWNLOADED, {
      content_type: 'greeting_card',
    });
  },

  // Track card sharing
  trackCardShared: (method = 'link') => {
    trackCustomEvent(FBEvents.CARD_SHARED, {
      content_type: 'greeting_card',
      share_method: method,
    });
  },

  // Track content views
  trackContentView: (contentName, contentCategory) => {
    trackEvent(FBEvents.VIEW_CONTENT, {
      content_name: contentName,
      content_category: contentCategory,
    });
  },

  // Track lead generation
  trackLead: (contentName = 'Newsletter Signup') => {
    trackEvent(FBEvents.LEAD, {
      content_name: contentName,
    });
  },

  // Track search
  trackSearch: (searchString) => {
    trackEvent(FBEvents.SEARCH, {
      search_string: searchString,
    });
  },
};

export default fbPixel;
